export default __webpack_public_path__ + "static/media/error-check.6eb61684.svg";